const getCircularPathRatio = (value) => {
    const minValue = 0;
    const maxValue = 100;
    const boundedValue = Math.min(Math.max(value, minValue), maxValue);
    return (boundedValue - minValue) / (maxValue - minValue);
};
export default getCircularPathRatio;
